import { render, staticRenderFns } from "./CreatePititim.vue?vue&type=template&id=b4451ec4"
import script from "./CreatePititim.vue?vue&type=script&lang=js"
export * from "./CreatePititim.vue?vue&type=script&lang=js"
import style0 from "./CreatePititim.vue?vue&type=style&index=0&id=b4451ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports